export default function getResource(label, vars = []) {
    const resources = {
        allStores: 'All Stores',
        chooseLocation: 'Choose a location'
    };
    return resources[label];
}
